import Layout from '@/layout';
var settingRouter = {
  path: '/setting',
  component: Layout,
  redirect: '/setting/IM-setting',
  name: 'setting',
  alwaysShow: true,
  meta: {
    title: '设置',
    icon: 'clipboard'
  },
  children: [{
    path: 'IM-setting',
    component: function component(resolve) {
      return require(['@/views/my-create/set/IM-setting/index.vue'], resolve);
    },
    name: 'IM-setting',
    meta: {
      title: 'IM设置',
      icon: ''
    }
  }, {
    path: 'sensitive-words',
    component: function component(resolve) {
      return require(['@/views/my-create/set/sensitive-words'], resolve);
    },
    name: 'sensitive-words',
    meta: {
      title: '敏感词词库',
      icon: ''
    },
    children: [{
      path: 'sensitive-list',
      component: function component(resolve) {
        return require(['@/views/my-create/set/sensitive-words/index.vue'], resolve);
      },
      name: 'sensitive-list',
      meta: {
        title: '敏感词词库',
        icon: ''
      }
    }, {
      path: 'sort-management',
      component: function component(resolve) {
        return require(['@/views/my-create/set/sort-management/index.vue'], resolve);
      },
      name: 'sort-management',
      meta: {
        title: '分类管理',
        icon: ''
      }
    }, {
      path: 'hit-sensitive-words',
      component: function component(resolve) {
        return require(['@/views/my-create/set/hit-sensitive-words/index.vue'], resolve);
      },
      name: 'hit-sensitive-words',
      meta: {
        title: '命中敏感词',
        icon: ''
      }
    }, {
      path: 'sensitive-word-configuration',
      component: function component(resolve) {
        return require(['@/views/my-create/set/sensitive-word-configuration/index.vue'], resolve);
      },
      name: 'sensitive-word-configuration',
      meta: {
        title: '敏感词配置',
        icon: ''
      }
    }]
  }, {
    path: 'entry-audit',
    component: function component(resolve) {
      return require(['@/views/my-create/set/entry-audit/index.vue'], resolve);
    },
    name: 'entry-audit',
    meta: {
      title: '入驻审核',
      icon: ''
    }
  }, {
    path: 'settlement-agreement',
    component: function component(resolve) {
      return require(['@/views/my-create/set/settlement-agreement/index.vue'], resolve);
    },
    name: 'settlement-agreement',
    meta: {
      title: '入驻协议',
      icon: ''
    }
  }, {
    path: 'management-standard',
    component: function component(resolve) {
      return require(['@/views/my-create/set/management-standard/index.vue'], resolve);
    },
    name: 'management-standard',
    meta: {
      title: '平台管理规范',
      icon: ''
    }
  }, {
    path: 'content',
    component: function component(resolve) {
      return require(['@/views/my-create/set/help-manual/article-management'], resolve);
    },
    name: 'content',
    meta: {
      title: '帮助手册',
      icon: ''
    },
    children: [
    // {
    //     path: 'article-management',
    //     component: (resolve) => require(['@/views/my-create/set/help-manual/article-management/index.vue'], resolve),
    //     name: 'article-management',
    //     meta: { title: '文章管理', icon: '' }
    // },
    // {
    //     path: 'article-classification',
    //     component: (resolve) => require(['@/views/my-create/set/help-manual/article-classification/index.vue'], resolve),
    //     name: 'article-classification',
    //     meta: { title: '文章分类', icon: '' }
    // },
    {
      path: 'articleManager',
      name: 'articleManager',
      component: function component() {
        return import('@/views/content/article/list');
      },
      meta: {
        title: '文章管理',
        icon: 'clipboard'
      }
    }, {
      path: 'articleCreat/:id?',
      name: 'articleCreat',
      component: function component() {
        return import('@/views/content/article/edit');
      },
      meta: {
        title: '添加文章',
        noCache: true,
        activeMenu: "/content/articleManager"
      }
    }, {
      path: 'classifManager',
      name: 'classifManager',
      component: function component() {
        return import('@/views/content/articleclass/list');
      },
      meta: {
        title: '文章分类',
        icon: 'clipboard'
      }
    }]
  }]
};
export default settingRouter;